import React, {useEffect, useState} from 'react'
import { doc,setDoc, getDoc, collection,addDoc} from "firebase/firestore";
import { db } from "../../firebase/config";
import { useParams } from 'react-router-dom';
export default function ApproveRetake() {
    let { uid } = useParams();
    const [userData, setUserData] = useState(null);
    const [responsed, setResponsed] = useState("");
    const [rejectReason, setRejectReason] = useState("");

    useEffect(() => {
      console.log(uid)
      const docRef = doc(db, 'users', uid);
      getDoc(docRef)
        .then((docSnap) => {
          if (docSnap.exists()) {
          setUserData(docSnap.data());
          setResponsed(docSnap.data().retakeRequest)
          }
        })
        .catch( (error)=>{
          console.log(error)
        });
    }, []);

    async function approveHandler(){
      const usersRef = doc(db, "users", uid);
      await setDoc(usersRef,{
        reqestSubmitted:false, 
        retakeRequest:"Approved",
        testTaken: false
      } , { merge: true });
      const newMailRef = collection(db, "approveRejectMails");
      addDoc(newMailRef, {
        to:userData.email,
        message: {
          subject:"Status Of Your Retake Quiz Request",
          html:"<div style='text-align: center;max-width: 300px;background-color: #f2f2f2;margin: auto;border-radius: 8px;padding: 20px;border: 1px solid #ccc;'>"+
          "<h2>Here is the response of your retake quiz request that you requested.</h2>"+
          "Status : <strong>Approved</strong><br>"+
          "<a href='https://adaptive-chinese-test.web.app/'>Click here to Retake quiz</a>"+
          "</div>"
        }
      }).then(() => {
        setResponsed('Approved')
        alert('Request status updated and email sent.');
      }).catch((error)=> error.message) 
    }
   async function rejectHandler(){
      const usersRef = doc(db, "users", uid);
      await setDoc(usersRef,{
        reqestSubmitted:true, 
        retakeRequest:"Rejected",
        rejectMessage:rejectReason,
        testTaken: true
      } , { merge: true });
      const newMailRef = collection(db, "approveRejectMails");
      addDoc(newMailRef, {
        to:userData.email,
        message: {
          subject:"Status Of Your Retake Quiz Request",
          html:"<div style='text-align: center;max-width: 300px;background-color: #f2f2f2;margin: auto;border-radius: 8px;padding: 20px;border: 1px solid #ccc;'>"+
          "<h2>Here is the response of your retake quiz request that you requested.</h2>"+
          "Status : <strong>Rejected</strong><br>"+
          "<fieldset><legend>Message:</legend> <p style='font-style:italic;'>"+rejectReason+"</p></fieldset>"+
          "</div>"
        }
      }).then(() => {
        setResponsed("Rejected")
        alert('Request status updated and email sent.');
      }).catch((error)=> error.message) 
    }

  return (
    <center>
      {userData && (
        <div style={{marginTop:"22px"}}>
        <h2 style={{fontWeight:"400"}}>Respond to <strong>{userData.email}</strong> with below options:</h2>
        <p>Current Status: <span style={{backgroundColor: "#4f9de2",padding: "5px",borderRadius: "5px",color: "white"}}>{responsed}</span></p>
        <p>Enter the message below if you want to reject the request</p>
        <textarea style={{minWidth: '410px'}} name="retakeReason" id="" value={rejectReason} onChange={(event) => setRejectReason(event.target.value)} cols="30" rows="10"></textarea><br/>
        <button style={{padding: "5px 50px",borderRadius: "1.625rem",border: "2px solid #4f9de2",fontSize: "1.25rem",cursor:"pointer"}} onClick={approveHandler} className="theme-btn">Approve</button>
        <button style={{marginLeft:"10px", padding: "5px 50px",borderRadius: "1.625rem",border: "2px solid #4f9de2",fontSize: "1.25rem", cursor:"pointer"}} onClick={rejectHandler} className="theme-btn">Reject</button>
      </div>
      )}
      
    </center>
  )
}
